<script setup lang="ts">
import { PhxsgCoreDivider } from '@sg-core/src/View/Components/Atoms/Divider';

type PhxsgDividerSpacing = '2' | '3' | '4' | '6' | null;
type PhxsgDividerColor = 'foreground' | null;

interface PhxsgDividerProps {
  vertical?: boolean;
  spacing?: PhxsgDividerSpacing;
  color?: PhxsgDividerColor;
}

defineProps<PhxsgDividerProps>();
</script>

<template>
  <PhxsgCoreDivider
    :class="[
      {
        'phxsg-divider--vertical': vertical,
        [`phxsg-divider--spacing-${spacing}`]: spacing,
        [`phxsg-divider--color-${color}`]: color,
      },
    ]"
  >
    <slot />
  </PhxsgCoreDivider>
</template>

<style src="./divider.css" />
